import { gql } from "@apollo/client";
import { useMutation } from "@bb-vendure/admin-ui/react";
const MUTATION = gql`
  mutation CreateAssetsCC($input: [CreateAssetInput!]!) {
    createAssets(input: $input) {
      ... on Asset {
        id
        name
        fileSize
      }
      ... on ErrorResult {
        message
      }
    }
  }
`;

export default function useUploadFile<T>() {
  return useMutation<T>(MUTATION);
}
